export const ANALYTICS_TYPE = {
  PRODUCTION: 'production',
  ORDER: 'order',
  ACTIVITY_REPORT: 'activityReport',
  STOCKS: 'stocks',
};
